import { Request } from '../base/Request';
import { Method } from 'axios';
import { ConfigurableProductSizeValueObject } from '@/types/joostconnector';

export default class MediaclipUploadImageRequest extends Request<
  {
    project_id: string;
    mediaclip_product_id: string;
    fc_product_sku: string;
    identifier: string;
    mediaclip_project_id: string;
  },
  {
    form_key: string;
    image: File;
    product_identifier: string;
    product_entity_id: number;
    selected_size_value: ConfigurableProductSizeValueObject;
  }
> {
  protected headers = {
    'Content-Type': 'multipart/form-data',
  };

  constructor() {
    super();
    // @ts-ignore
    this.data.form_key = hyva.getFormKey();
  }

  protected getEndPoint(): string {
    return window.mediaclip_config.uploadImage;
  }

  protected getMethod(): Method {
    return 'POST';
  }

  public setImage(image: File): this {
    this.data.image = image;
    return this;
  }

  public setIdentifier(identifier: string): this {
    this.data.product_identifier = identifier;
    return this;
  }

  public setProductEntityId(productEntityId: number): this {
    this.data.product_entity_id = productEntityId;
    return this;
  }

  public selectedSizeValue(
    selectedSizeValue: ConfigurableProductSizeValueObject
  ): this {
    this.data.selected_size_value = selectedSizeValue;
    return this;
  }
}
